import React from "react";
import PropTypes from "prop-types";

export function TextInput(props) {
 
    let wrapperClass = "form-group row ";
    if (props.error.length > 0) {
        wrapperClass += "has-error";
    }
    return (
        <div className={wrapperClass}>

            <label htmlFor={props.id} className={props.labelStyle ? props.labelStyle :"col-4 "}>{props.isRequired=='true' ? <sup style={{ color: "red" }}>*</sup> : <sup>&nbsp;</sup>} {props.label} </label>
            <div className={props.inputStyle ? props.inputStyle : "field col-8" }>
                <input
                    type={props.type}
                    id={props.id}
                    className={"form-control " + (props.error ? "is-invalid" : "")}
                    name={props.name}
                    value={props.value}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    placeholder={props.placeholder}
                    disabled={props.disable} 
                    maxLength={props.maxLength}
                    onKeyUp={props.onKeyUp}
                  
                    />
                   
                {props.error && <div className="invalid-feedback">{props.error}</div>}
            </div>
        </div>
    )
}

TextInput.propTypes = {
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur:PropTypes.func.isRequired,
    error: PropTypes.string,
    isRequired: PropTypes.string,
    placeholder: PropTypes.string,
    disable: PropTypes.bool,
    labelStyle: PropTypes.string,
    inputStyle: PropTypes.string,
    onKeyUp:PropTypes.func.isRequired
}

TextInput.defaultProps = {
    error: "" // to remove the empty check for error in this component
}